// Preserve a reminder's destination through sign-in without allowing external redirects.
export function signedInDestination(value) {
  if (typeof value !== 'string') return '/ai';
  if (!value.startsWith('/') || value.startsWith('//') || value.includes('\\') ||
      [...value].some(character => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)) return '/ai';
  try {
    const target = new URL(value, 'https://timelyzer.invalid');
    if (target.origin !== 'https://timelyzer.invalid' || ['/', '/login', '/register', '/forgot-password', '/reset-password'].includes(target.pathname)) return '/ai';
    return target.pathname + target.search + target.hash;
  } catch { return '/ai'; }
}

export const signInUrl = destination => `/login?returnTo=${encodeURIComponent(signedInDestination(destination))}`;
